export default __webpack_public_path__ + "img/sidebar_album.a5f7bf8f.svg";